export function cleanup(text: string): string {
  return text.toLowerCase().trim();
}

export function isSubString(text1: string, text2: string): boolean {
  text1 = cleanup(text1);
  text2 = cleanup(text2);
  return text1.indexOf(text2) !== -1 || text2.indexOf(text1) !== -1;
}

export function isEmpty(text: string): boolean {
  return cleanup(text) === '';
}

export function camelCase(str:string): string {
  return str.replace(/([-_][a-z])/ig, ($1) => {
    return $1.toUpperCase()
      .replace('-', '')
      .replace('_', '');
  });
}